"use strict";

import throttle from "lodash/throttle";
import imagesLoaded from "imagesloaded";

function listen(item, accordionItems, exclusive = true) {
  if (!item.h3) return;

  item.h3.addEventListener("click", () => {
    if (!exclusive) {
      if (item.isOpen) {
        closeItem(item);
      } else {
        openItem(item);
      }
      return;
    }

    for (const otherItem of accordionItems) {
      if (otherItem.el === item.el) {
        closeOtherItems(item, accordionItems);
        openItem(item);
      } else {
        closeItem(otherItem);
      }
    }
  });
}

function closeOtherItems(currentItem, accordionItems) {
  for (const item of accordionItems) {
    if (item.el !== currentItem.el) {
      closeItem(item);
    }
  }
}

function removeChild(item) {
  if (item.picture) {
    item.picture.remove();
  }
  if (item.testimonial) {
    item.testimonial.remove();
  }
  if (item.video) {
    item.video.remove();
  }
}

function getRightMedia(item) {
  if (!item.right) return null;
  const children = Array.from(item.right.children).filter(
    (el) => !el.classList.contains("default-payload")
  );
  return children[item.index] || null;
}

function hideDefaultImage(item) {
  if (item.parent) {
    item.parent.classList.add("has-opened");
  }
}

function openTestimonial(item) {
  item.right.classList.add("has-testimonial");
  const child = getRightMedia(item);
  if (!child) return;
  child.classList.add("active");
  item.right.style.minHeight = child.clientHeight + "px";
}

function openPicture(item) {
  item.right.classList.add("has-picture");
  const child = getRightMedia(item);
  if (!child) return;
  child.classList.add("active");
  imagesLoaded(child, () => {
    if (child.clientWidth >= item.right.clientWidth) {
      item.right.classList.add("constrain-width");
    } else {
      item.right.classList.remove("constrain-width");
    }
  });
}

function openVideo(item) {
  item.right.classList.add("has-video");
  const child = getRightMedia(item);
  if (!child) return;
  child.classList.add("active");
  if (child.play) {
    child.play();
  }
  item.right.style.minHeight = child.clientHeight + "px";
}

function applyContentHeight(item) {
  if (!item.content) return;
  item.content.style.maxHeight = item.content.scrollHeight + 25 + "px";
}

function openItem(item) {
  item.isOpen = true;
  item.el.classList.add("active");
  applyContentHeight(item);

  window.addEventListener(
    "load",
    throttle(() => {
      applyContentHeight(item);
    }, 25)
  );

  window.addEventListener(
    "resize",
    throttle(() => {
      if (item.el.classList.contains("active")) {
        applyContentHeight(item);
      }
    }, 25)
  );

  if (item.content && item.content.querySelector("img")) {
    imagesLoaded(item.content, () => applyContentHeight(item));
  }

  setTimeout(() => {
    hideDefaultImage(item);
    if (item.right) {
      item.right.classList.remove(
        "has-video",
        "has-picture",
        "has-testimonial"
      );
    }
    if (item.testimonial) {
      openTestimonial(item);
    }
    if (item.picture) {
      openPicture(item);
    }
    if (item.video) {
      openVideo(item);
    }
  }, item.animationTime);
}

function closeItem(item) {
  item.isOpen = false;
  item.el.classList.remove("active");
  if (item.content) {
    item.content.style.maxHeight = "0";
  }
  if (item.right) {
    item.right.style.minHeight = "0";
  }
  const child = getRightMedia(item);
  if (child) {
    child.classList.remove("active");
  }
  
}

document.querySelectorAll(".accordion-item").forEach((el, i) => {
  el.addEventListener("click", () => {
    if (!el.classList.contains("active")) {
      document.querySelector(".accordion-item.active").classList.remove("active");
      el.classList.add("active");
    }
  });
});

const accordions = document.querySelectorAll(".accordion");
window.accordion_items = [];

if (accordions) {
  Array.from(accordions).forEach((el) => {
    const itemElements = el.querySelectorAll('.item');
    const accordionItems = [];

    const exclusive = !el.classList.contains("accordion--toggle");

    itemElements.forEach(function(itemElement, index) {
      const heading = itemElement.querySelector("h3, h4");
      const content = itemElement.querySelector(".item-content");
      if (!heading || !content) return;

      const item_object = {
        index: index,
        el: itemElement,
        parent: el,
        h3: heading,
        right: el.querySelector(".right"),
        content: content,
        content_size: content.scrollHeight,
        picture: itemElement.querySelector(".image-payload"),
        video: itemElement.querySelector("video"),
        testimonial: itemElement.querySelector(".testimonial"),
        isOpen: false,
        animationTime: 400,
      };

      listen(item_object, accordionItems, exclusive);
      removeChild(item_object);
      closeItem(item_object);

      accordionItems.push(item_object);
      window.accordion_items.push(item_object);
    });
  });
}

